import { render, staticRenderFns } from "./teacherDialog.vue?vue&type=template&id=fae50e7e&scoped=true"
import script from "./teacherDialog.vue?vue&type=script&lang=js"
export * from "./teacherDialog.vue?vue&type=script&lang=js"
import style0 from "./teacherDialog.vue?vue&type=style&index=0&id=fae50e7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae50e7e",
  null
  
)

export default component.exports